import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useRef } from 'react';

gsap.registerPlugin(ScrollTrigger);



const Photocouple = ({details}) => {
const sectionRef = useRef(null);
  const topPatternRef = useRef(null);
  const cardRef = useRef(null);
  const bottomPatternRef = useRef(null);

  //  useGSAP(() => {

  //   // Safety check
  //   if (
  //     !topPatternRef.current &&
  //     !cardRef.current &&
  //     !bottomPatternRef.current
  //   ) {
  //     return;
  //   }

  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: sectionRef.current,
  //       start: "top 85%",
  //       once: true,
  //     },
  //   });

  //   // Top lace
  //   if (topPatternRef.current) {
  //     tl.fromTo(
  //       topPatternRef.current,
  //       {
  //         opacity: 0,
  //         y: -25,
  //       },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         duration: 0.8,
  //         ease: "power2.out",
  //       },
  //       0
  //     );
  //   }

  //   // Middle cream card
  //   if (cardRef.current) {
  //     tl.fromTo(
  //       cardRef.current,
  //       {
  //         opacity: 0,
  //         y: 25,
  //         scale: 0.97,
  //       },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         scale: 1,
  //         duration: 0.9,
  //         ease: "power2.out",
  //       },
  //       0.12
  //     );
  //   }

  //   // Bottom lace
  //   if (bottomPatternRef.current) {
  //     tl.fromTo(
  //       bottomPatternRef.current,
  //       {
  //         opacity: 0,
  //         y: 25,
  //       },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         duration: 0.8,
  //         ease: "power2.out",
  //       },
  //       0.18
  //     );
  //   }

  // }, {
  //   scope: sectionRef,
  // });


    useGSAP(() => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: sectionRef.current,
      start: "top 85%",
      once: true,
    },
  });

  // Top lace
  tl.from(
    topPatternRef.current,
    {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
    },
    0
  );

  // Main card
  tl.from(
    cardRef.current,
    {
      opacity: 0,
      y: 20,
      duration: 0.8,
      ease: "power2.out",
    },
    0.1
  );

  // Bottom lace
  tl.from(
    bottomPatternRef.current,
    {
      opacity: 0,
      duration: 0.6,
      ease: "power2.out",
    },
    0.15
  );

}, {
  scope: sectionRef,
});

   const renderPersonCard=({
    image,
    alt,
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  })=>{
     if (!image?.url) return null;
     const baseUrl = image.url;

     return(
       <div className="t4-single-couple-container" data-aos="fade-up">
        <div className="t4-couple-grandparents">
          {grandParentsName && (
            <p>
              {grandParentsPrefix} {grandParentsName}
            </p>
          )}
           </div>
               <img src={baseUrl} 
          alt={alt} 
          srcSet={`
         ${baseUrl.replace('/upload/', '/upload/w_320/')} 320w,
          ${baseUrl.replace('/upload/', '/upload/w_640/')} 640w,
           ${baseUrl.replace('/upload/', '/upload/w_1080/')} 1080w
         `}
           sizes="(max-width: 320px) 320px,
               (max-width: 640px) 640px,
               (max-width: 1080px) 1080px"
          className='t4-couple-image' />
         
         
          <h1 className='t4-couple-name'>{fullname}</h1>
            <div className="t4-couple-parents">
                       {parentsName && (
            <p>
              {parentprefix} {parentsName}
            </p>
          )}
                      </div>
      
       </div>
     )
  }

  const groomCard=()=>{
   return renderPersonCard({
     image:details?.groomImage,
      alt:"groomImage",
       fullname:details?.groomFullName || "Groom Full Name",
      parentprefix:details?.groomParentsPrefix,
      parentsName:details?.groomParents,
      grandParentsPrefix:details?.groomGrandParentsPrefix,
      grandParentsName:details?.groomGrandParents
    }
    )
  }

   const brideCard=()=>
    renderPersonCard({
      image:details?.brideImage,
      alt:"brideImage",
      fullname:details?.brideFullName || "Bride Full Name",
      parentprefix:details?.brideParentsPrefix,
      parentsName:details?.brideParents,
      grandParentsPrefix:details?.brideGrandParentsPrefix,
      grandParentsName:details?.brideGrandParents
    })


  return (
    <section className="couple-section photo-couple theme4"   ref={sectionRef}>

      {/* Top lace */}
      <img
        src="/theme4-couple-section-decor.png"
        alt=""
        ref={topPatternRef}
        className="photo-couple-pattern photo-couple-pattern-top"
      />

      {/* Cream panel */}
      <div className="photo-couple-container"  ref={cardRef}>

        <div className="theme4-couple-content">
          <h1 className="t4-couple-heading" data-aos="fade-up">
          {details?.sectionHeading}
          </h1>
           <div className="t4-couple-wrapper">

             {details?.displayOrder==="groomFirst"?<>
                    {groomCard()}
                     <span className="t4-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}

            </>:<>
                      {brideCard()}
                         <span className="t4-couple-divider" data-aos="fade-up">
                        &
                    </span>
                       {groomCard()}
            </>}

           </div>
        </div>

      </div>

      {/* Bottom lace */}
      <img
        src="/theme4-couple-section-decor.png"
        alt=""
        ref={bottomPatternRef}
        className="photo-couple-pattern photo-couple-pattern-bottom"
      />

    </section>
  )
}

export default Photocouple